import { BillOfMaterialsTemplateBindingStatus } from "@redotech/crdb-enums/inventory/bill-of-materials-template-binding-status";
import { BillOfMaterialsTemplateStatus } from "@redotech/crdb-enums/inventory/bill-of-materials-template-status";
import {
  billOfMaterialsIdFormat,
  billOfMaterialsTemplateBindingIdFormat,
  billOfMaterialsTemplateIdFormat,
} from "@redotech/redo-fulfillment-id";
import {
  BomTemplateBindingSpec,
  BomTemplateSpec,
} from "@redotech/redo-inventory-common/bill-of-materials/bom-template-spec";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const bomTemplateStatusSchema = createEnum(
  BillOfMaterialsTemplateStatus,
);

export const bomTemplateBindingStatusSchema = createEnum(
  BillOfMaterialsTemplateBindingStatus,
);

export const bomTemplateRowStatusSchema = createEnum([
  "ready",
  "draft",
  "skipped",
]);

const BomTemplateSummary_ = z.object({
  id: billOfMaterialsTemplateIdFormat.schema,
  name: z.string(),
  status: bomTemplateStatusSchema,
  spec: BomTemplateSpec,
  bindingCount: z.number().int(),
});
export const BomTemplateSummary: z.ZodType<BomTemplateSummary> =
  BomTemplateSummary_;
export interface BomTemplateSummary extends z.infer<
  typeof BomTemplateSummary_
> {}

const BomTemplateBindingFamily_ = z.object({
  side: z.string(),
  productFamilyId: productFamilyIdFormat.schema,
  title: z.string(),
});
export const BomTemplateBindingFamily: z.ZodType<BomTemplateBindingFamily> =
  BomTemplateBindingFamily_;
export interface BomTemplateBindingFamily extends z.infer<
  typeof BomTemplateBindingFamily_
> {}

const BomTemplateBindingSummary_ = z.object({
  id: billOfMaterialsTemplateBindingIdFormat.schema,
  templateId: billOfMaterialsTemplateIdFormat.schema,
  templateName: z.string(),
  name: z.string(),
  status: bomTemplateBindingStatusSchema,
  spec: BomTemplateBindingSpec,
  families: z.array(BomTemplateBindingFamily_),
  approvedAt: z.string().nullable(),
  updatedAt: z.string(),
});
export const BomTemplateBindingSummary: z.ZodType<BomTemplateBindingSummary> =
  BomTemplateBindingSummary_;
export interface BomTemplateBindingSummary extends z.infer<
  typeof BomTemplateBindingSummary_
> {}

const BomTemplatePreviewInput_ = z.object({
  slot: z.string(),
  productId: productIdFormat.schema,
  title: z.string(),
  sku: z.string().nullable(),
  quantity: z.number().int(),
});
export const BomTemplatePreviewInput: z.ZodType<BomTemplatePreviewInput> =
  BomTemplatePreviewInput_;
export interface BomTemplatePreviewInput extends z.infer<
  typeof BomTemplatePreviewInput_
> {}

const BomTemplatePreviewRow_ = z.object({
  outputProductId: productIdFormat.schema,
  outputTitle: z.string(),
  outputSku: z.string().nullable(),
  generationKey: z.string(),
  status: bomTemplateRowStatusSchema,
  facets: z.record(z.string(), z.string().nullable()),
  inputs: z.array(BomTemplatePreviewInput_),
  outputQuantity: z.number().int(),
  draftReasons: z.array(z.string()),
});
export const BomTemplatePreviewRow: z.ZodType<BomTemplatePreviewRow> =
  BomTemplatePreviewRow_;
export interface BomTemplatePreviewRow extends z.infer<
  typeof BomTemplatePreviewRow_
> {}

const BomTemplatePreviewConflict_ = z.object({
  outputProductId: productIdFormat.schema,
  bomId: billOfMaterialsIdFormat.schema,
});
export const BomTemplatePreviewConflict: z.ZodType<BomTemplatePreviewConflict> =
  BomTemplatePreviewConflict_;
export interface BomTemplatePreviewConflict extends z.infer<
  typeof BomTemplatePreviewConflict_
> {}
